import Page from './page/[pageNo]';

export { getStaticProps } from './page/[pageNo]';
export default Page;
